import "./NewsPage.scss";
// REACT, ROUTER & REDUX
import React from "react";
import { NavLink } from "react-router-dom";

// SVGs & IMGs
import newsHeaderFigure from "../img/header-news.svg";

/*
NEWS PAGE COMPONENT INFORMATION
  Latest news, Upcoming features & Known bugs
*/

export default function NewsPage() {
  return (
    <div className="news-page">
      <header>
        <figure>
          <img src={newsHeaderFigure} alt="news-header-figure" />
        </figure>
        <h1 className="calculator-page__heading">News</h1>
      </header>

      {/* ------------------------------ latest news section ------------------------------ */}
      <section>
        <h2 style={{ textAlign: "center" }}>latest news</h2>
        <article>
          <h3>Its Electric</h3>
          <p>
            As we are entering turbulent times with electric prices sky
            rocketing and wars are being waged between pro petroleum and pro
            electric... We need to ask ourselves one question... How do I
            calculate? As a primary focus, we will try to add more "electric"
            themes calculators. At first very basic ones, to set the structure.
            We do hope these calculators help you in understanding that
            petroleum sucks (not biased).
          </p>
        </article>
        <article>
          <h3>Tutorial online!</h3>
          <p>
            We are super happy to announce that the interactive tutorial on how
            to use the calculator is finally online! It can be found in the home
            page. We would love for our users to try it out, to really
            understand the calculators and all of their finesse!
          </p>
          <p>
            PS: sadly the tutorial is only available for computer devices and
            not devices with touch screens
          </p>
        </article>
        <article>
          <h3>Welcome to the family mr Converter!</h3>
          <p>
            We have now extended the calculator family with a new calculator
            unit, the Converter!
          </p>
          <p>
            With the converter you can select a certain base quantity (length,
            volume etc) and convert values between e.g. meters and inches. Ever
            wanted to compare meter, inch and yards at the same time as you
            compare kilograms, pounds and ounces? Simple enough, just add two
            converters!
          </p>
        </article>
        <NavLink
          to={"archive"}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="rectangular-button inverse-color">
            archived news
          </button>
        </NavLink>
      </section>

      {/* ------------------------------ upcoming features section ------------------------------ */}

      <section>
        <h2 style={{ textAlign: "center" }}>upcoming features</h2>

        <article>
          <h3>Encylopedia</h3>
          <p>
            As the abacalculator site grows so does the confusion. There has
            been many features added since release and much more to come.
          </p>
          <p>
            To cure the sickness of confusion of our users, we will prioritize a
            new feature. Encyclopedia!
          </p>
          <p>
            The idea is that all features within this webapp and all upcoming
            features, are to be presented there.
          </p>
        </article>
        <article>
          <h3>A... New... Unit</h3>
          <p>One word. Chart unit. Ok, two words!</p>
          <p>
            Chart unit will be a new member to the calculator family and its
            sole focus will be to allow user to plot simple graphs. The Chart
            unit itself has a lot of potential; Both plotting multiple types of
            graphs and also accepting user inputs or connect to calculator unit
            output.
          </p>
          <p>
            The chart unit is in an ongoing development and should be released
            in the near future.
          </p>
        </article>
        <article>
          <h3>To connect our not to connect</h3>
          <p>
            Out of the many feedbacks received, a common one has been to allow
            calculators to connect their values with each other.
          </p>
          <p>
            Say you are calculating the area of a square and a triangle. And say
            for an example that you want whatever area that is being calculated
            of the square to be equal to the area of the triangle.
          </p>
          <p>
            We will try to make this suggested feature a reality in the near
            future!
          </p>
        </article>
      </section>

      {/* ------------------------------ known bugs section ------------------------------ */}

      <section>
        <h2 style={{ textAlign: "center" }}>known bugs</h2>
        <article>
          <h3>Data not saved on browser shut down</h3>
          <p>
            An important feature has been that all your calculation are saved,
            even if you close the browser. However, it seems that when you use
            Microsoft Edge and close your browser, all you data is being
            deleted.
          </p>
          <p>
            For now we recommend that you use the other browsers, such as
            Chrome, Safari or Firefox on your computer-, tablet- and/or
            mobile-device.
          </p>
        </article>
        <article>
          <h3>Order of calculators not set</h3>
          <p>
            Whenever you end a session and start the abacus-calculator again, it
            will reload all calculators and receipts from your browser storage.
            There is then a possibility that the order of your calculators will
            not be the same.
          </p>
          <p>
            This is a simple fix, but the structure of every calculator needs to
            be changed to solve this. Expect a solution soon!
          </p>
        </article>
        <article>
          <h3>Not all receipts are being deleted</h3>
          <p>
            In the Receipt list window, there is a delete all button. However,
            when you have more than one receipt item and delete them all, it
            will look like they all have been deleted. But when you restart the
            browser, there is always one receipt item remaining. You can of
            course still delete that single last receipt as usual.
          </p>
          <p>
            This is a super weird bug, but surely not impossible to solve... Or
            is it?
          </p>
        </article>
      </section>
    </div>
  );
}
